import { Box, Stack, Text } from '@redbubble/design-system';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import type { UserInfo } from '@redbubble/next/types';
import { useUserInfo } from '@redbubble/next-provider';
import { useState } from 'react';
import { ProductFeatures } from './ProductFeatures';
import styles from './ProductFeaturesReviews.module.scss';
import { ProductReviews } from './ProductReviews';
import { ProductReviewModal } from './ProductReviewsModal';
import { useReviews } from './useReviews';
export const messages = defineMessages({
  productFeatures: { defaultMessage: 'Product features' },
});

export interface ProductFeaturesReviewsProps {
  inventoryItemId: string;
  productTypeId: string;
}

export const ProductFeaturesReviews = ({
  inventoryItemId,
  productTypeId,
}: ProductFeaturesReviewsProps) => {
  const intl = useIntl();
  const [{ locale }] = useUserInfo<UserInfo>();
  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);
  const {
    reviews,
    loading: loadingReviews,
    refresh: refreshReviews,
  } = useReviews();

  const handleReviewSummaryClick = () => {
    refreshReviews({ inventoryItemId, locale });
    setIsReviewModalOpen(true);
  };

  const handleReviewModalClosed = () => {
    setIsReviewModalOpen(false);
  };

  return (
    <Stack spacing="s" data-testid="product-features-reviews">
      <Box className={styles.featuresReviewHeader}>
        <Text display="block" type="display3" element="h2">
          {intl.formatMessage(messages.productFeatures)}
        </Text>
        <ProductReviews
          inventoryItemId={inventoryItemId}
          productTypeId={productTypeId}
          onClick={handleReviewSummaryClick}
          data-test-id="productfeaturesreviews-summary"
        />
      </Box>
      <ProductFeatures />
      <ProductReviewModal
        reviews={reviews}
        isOpen={isReviewModalOpen}
        onCloseRequested={handleReviewModalClosed}
        loading={loadingReviews}
      />
    </Stack>
  );
};
